export const containerTransition = {
  hidden: {
    // opacity: 0,
    transition: {
      staggerChildren: 0.1,
      duration: 0.2,
      when: 'beforeChildren',
    },
  },
  show: {
    // opacity: 1,
    transition: {
      staggerChildren: 0.1,
      duration: 0.2,
      when: 'beforeChildren',
    },
  },
  exit: {
    // opacity: 0,
    transition: {
      staggerChildren: 0.1,
      duration: 0.2,
      when: 'afterChildren',
    },
  },
};

const defaultDuration = 0.3;
const glintDuration = 1.5;
export const itemTransition = {
  hidden: {
    // opacity: 0,
    // y: 0,
    // scale: 1.025,
    '--backdrop-blur-radius': 0,
    '--color-progress': 0,
    '--turn-progress': 0.5,
    '--pos-progress': 0,
    transition: { duration: defaultDuration },
  },
  show: {
    // opacity: 1,
    // y: 0,
    // scale: 1,
    '--backdrop-blur-radius': [0, 0, 1],
    '--color-progress': [0, 0, 1, 0],
    '--turn-progress': [0.5, 0.5, 0.3],
    '--pos-progress': [0, 0, 1],

    transition: {
      default: { duration: defaultDuration },
      '--backdrop-blur-radius': { duration: defaultDuration * 2, times: [0, 0.5, 1] },
      '--color-progress': { duration: 2, times: [0, defaultDuration / glintDuration, 0.4, 1] },
      '--turn-progress': { duration: 2, times: [0, defaultDuration / glintDuration, 1] },
      '--pos-progress': { duration: 2, times: [0, defaultDuration / glintDuration, 1] },
    },
  },
  exit: {
    // opacity: 0,
    // y: 10,
    // scale: 0.95,
    '--backdrop-blur-radius': 0,
    transition: { default: { duration: 0.3 }, '--backdrop-blur-radius': { duration: 0.01 } },
  },
};
